// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// IE 11 compatability fix
var Promise = require('es6-promise').Promise;
require('es6-promise').polyfill();

import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from '@/components/App'
import router from './router'
import store from './store'
import Meta from 'vue-meta'
import { ClientTable } from 'vue-tables-2'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'

Vue.config.productionTip = false

axios.defaults.baseURL = process.env.API_BASE || 'http://' + window.location.hostname + ':3000/'
axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('accessToken')

// Interceptor for failed responses -- using this to log users out if auth expired.
axios.interceptors.response.use((res) => res, (err) => {
  // Make sure there's a response, make sure this is an API request, make sure we're only handling unauthorized responses
  if (err.response && (err.response.config.baseURL == process.env.API_BASE || err.response.config.baseURL == 'http://' + window.location.hostname + ':3000/') && (err.response.status == 401 || err.response.status == 403)) {
    //router.push('logout');
  }
})

Vue.use(VueAxios, axios)
Vue.use(ElementUI, { locale })
Vue.use(store)
Vue.use(router)
Vue.use(Meta)
Vue.use(ClientTable)


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  render: h => h(App),
  template: '<App/>'
}).$mount('#app')


cssVars({
});